module.exports = __webpack_public_path__ + "static/media/LV3@4x.28c6ba03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/LV/LV3@4x.png
// module id = 681
// module chunks = 0